/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{create as e}from"../../../../core/libs/gl-matrix-2/factories/mat3f32.js";import{TiledDisplayObject as r}from"./TiledDisplayObject.js";class t extends r{_createTransforms(){return{displayViewScreenMat3:e(),tileMat3:e()}}}export{t as RenderableTile};
